module.exports = __webpack_public_path__ + "static/media/alipayplus.0ebe6942.svg";